<template>
  <div class="topicContnet">
    <!-- <nav01 title="福利活动"></nav01> -->
    <div class="topicTitle" @click.stop="fullScreenClick">
      <div class="title">{{ state.topicTitle }}</div>
      <div class="content">
        <!-- 游戏信息 -->
        <div class="gameInfo" v-if="state.topicType != 3">
          <div class="gameInfo_title">
            <h4>
              {{ state.topicGameTitle }}
            </h4>
            <span v-if="state.topicGameInfo">↓ 快点击下方卡片下载游戏吧 ↓</span>
            <div
              v-if="state.topicGameInfo"
              class="gameDetail"
              @click="goGamedetails"
            >
              <div>
                <img :src="state.topicGameInfo.pic1" alt="" />
                <div class="gameInfo">
                  <h3>{{ state.topicGameInfo.gamename }}</h3>
                  <p>点击卡片查看游戏详情</p>
                </div>
              </div>
              <img src="../../assets/topic/go.png" alt="" />
            </div>
          </div>
        </div>
        <!-- 话题详情 -->
        <p v-html="state.topicContent" @click.stop="openEditorImg" class="article-content"></p>
      </div>

      <!-- 往日话题入口 -->
      <div class="beforeTopic">
        <div class="beforeLeft">
          <span>1楼 · {{ state.topicTime }} </span>
        </div>
        <div class="beforeRight" @click="goBefore">
          <p>查看往期活动</p>
          <img src="../../assets/topic/goBeforeActivity.png" alt="" />
        </div>
      </div>
    </div>

    <p class="empty" @click.stop="fullScreenClick"></p>

    <!-- 话题评论 -->
    <div class="topicComment" @click.stop="fullScreenClick">
      <div class="commentTitle">
        <h3>
          评论 <span>{{ state.totalComment }}</span>
        </h3>
        <p class="sortClass">
          <span
            :class="[state.sortFlag ? 'sortActive' : '']"
            @click="changeSort('n')"
            >最新</span
          >
          <span
            :class="[state.sortFlag ? '' : 'sortActive']"
            @click="changeSort('f')"
            >最早</span
          >
        </p>
      </div>
      <van-list
        v-model:loading="state.loading"
        :finished="state.finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell
          v-for="(item, index) in state.commentList"
          :key="item + 'comment'"
        >
          <template #value>
            <topicItem
              :data="item"
              :like="state.likeArr"
              v-on:like-this-comment="likeThisComment"
              :topicType="state.topicType"
              @openInagePreview="openInagePreview"
            >
              <template #index>
                <span v-if="state.sort == 1" class="commentIndex"
                  >{{ index + 2 }}楼</span
                >
                <span v-else class="commentIndex"
                  >{{ state.totalComment - index + 1 }}楼</span
                >
              </template>
            </topicItem>
          </template>
        </van-cell>
      </van-list>
    </div>

    <!-- 评论输入区 -->
    <div class="myReview">
      <topicComment
        ref="commentPublic"
        :id="state.topicId"
        :gid="state.gid"
        :topicType="state.topicType"
        @refreshComment="refreshComment"
      >
      </topicComment>
    </div>
  </div>
</template>
<script setup>
import { reactive, onActivated, defineEmits, ref, onDeactivated } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import topicItem from "./components/topicItem.vue";
import topicComment from "@/views/topic/components/topicComment";
import { timeDifference } from "@/utils/date.js";
// 导入话题详情接口
import {
  getTopicDetail,
  getTopicComment,
  likeComment,
} from "@/api/yzCommunity";
// 表情转换
import { enCodeEmoji, deCodeEmoji } from "@/utils/emojiToCode";
import { getQueryString } from "@/utils/location";
import { setToken, getToken, removeToken } from "@/utils/auth";
// import store from "@/store";
const store = useStore();
const router = useRouter();
const state = reactive({
  commentList: [],
  loading: false,
  finished: false,
  imgCommentFlag: false, // 图片评论标识
  showBottom: false, // 评论回复弹窗
  inputText: "",

  topicTitle: "",
  topicGameTitle: "",
  topicTime: "",
  topicId: "5255",
  // 话题内容
  topicContent: "",
  // 话题内的游戏信息
  topicGameInfo: {},
  gid: 0,
  // 已点赞的评论
  likeArr: [],
  // 评论总数
  totalComment: 0,

  sortFlag: true, // 排序标识
  sort: 0,
  // 话题类型
  topicType: 1,
});

const commentPublic = ref(null);

onMounted(() => {});

onActivated(() => {
  state.topicId = getQueryString("topicId");
  // console.log("话题详情页面激活");
  getTopicDetailData();
  // 获取话题评论详情
  // getTopicCommentDetail();
  pagecode = 1;
  state.commentList = [];
  state.finished = false;
  state.loading = false;
  onLoad();
});

onDeactivated(() => {
  // console.log("话题详情页面失活");
  state.topicId = "";
  state.topicTitle = "";
  state.topicTime = "";
  state.topicContent = "";
  state.topicGameInfo = {};
  state.gid = 0;
  state.topicGameTitle = "";
  state.likeArr = [];
  state.totalComment = 0;
  state.sortFlag = true;
  state.sort = 0;
  pagecode = 1;
  state.commentList = [];
  state.finished = false;
  state.loading = false;
});

// 获取话题详情
const getTopicDetailData = async () => {
  const res = await getTopicDetail({
    // id: "5255",
    id: state.topicId,
  });
  // console.log("话题详情-----------------", res.data.data);
  // 话题详情
  state.topicTitle = res.data.data.post_title;
  // 发布时间
  state.topicTime = res.data.data.post_date.slice(0, 10);
  // 话题内容
  state.topicContent = deCodeEmoji(res.data.data.post_content);
  // 话题内的游戏信息
  state.topicGameInfo = res.data.data.gameinfo;
  state.gid = res.data.data.gid;
  state.topicGameTitle = res.data.data.post_excerpt;
};

// 设置一个表示符表示异步请求是否完成,未完成就阻断
var isFetchComments = false;

var pagecode = 1;
// 获取话题评论详情
const getTopicCommentDetail = async () => {
  // console.log("分页页数----", pagecode);
  isFetchComments = true;
  await getTopicComment({
    posts: state.topicId,
    uid: getQueryString("uid"),
    pagecode: pagecode,
    sort: state.sort,
  }).then((res) => {
    // console.log("话题评论列表数据----", res.data.c);
    if (res.data.a == "1") {
      if (pagecode == 1) {
        state.commentList = [];
      }
      state.totalComment = res.data.c.count;
      state.topicType = res.data.c.htj_type;
      let data = res.data.c.lists;
      data.forEach((item, index) => {
        item.content = deCodeEmoji(item.content);
        // isgood为1且id不在state,likearr内
        if (item.isgood == 1 && !state.likeArr.includes(item.id)) {
          state.likeArr.push(item.id);
        }
        // 将createtime转换为时间戳
        item.createtime = timeDifference(item.createtime);
      });
      state.commentList = state.commentList.concat(data);
      // 将content中的表情转换为code
      if (pagecode > res.data.c.total_page) {
        state.finished = true;
      }
      pagecode++;
      isFetchComments = false;
    }
  });
  state.loading = false;
};

const goGamedetails = (tid) => {
  window.document.location = "gogame://" + state.gid;
};

// 评论排序依据
const changeSort = (n) => {
  if (n == "n") {
    state.sortFlag = true;
    state.sort = 0;
  } else {
    state.sortFlag = false;
    state.sort = 1;
  }
  pagecode = 1;
  state.commentList = [];
  state.finished = false;
  state.loading = false;
  onLoad();
};

const likeThisComment = (id) => {
  // console.log('点赞的评论id---------',id)
  state.commentList.forEach((item) => {
    if (item.id == id) {
      if (item.isgood == "1") {
        item.isgood = "0";
        item.good--;
        state.likeArr.splice(state.likeArr.indexOf(item.id), 1);
      } else {
        item.isgood = "1";
        item.good++;
        state.likeArr.push(item.id);
      }
    }
  });
  likeComment({
    comments_id: id,
    uid: getQueryString("uid"),
  }).then((res) => {
    console.log("点赞评论的返回数据---------", res);
  });
};

const goBefore = () => {
  // console.log("查看往期活动");
  router.push({
    path: "/newtopic/agoTopic",
    query: {
      uid: getQueryString("uid"),
      mobile: getQueryString("mobile"),
    },
  });
};

const onLoad = async () => {
  // console.log(isFetchComments)
  if (isFetchComments) {
    return;
  }
  await getTopicCommentDetail();
};

// 子组件调用刷新评论数据
const refreshComment = () => {
  (pagecode = 1), (state.commentList = []);
  state.finished = false;
  state.loading = false;
  getTopicCommentDetail();
};

// 点击全屏
const fullScreenClick = () => {
  // 触发子组件事件，关闭表情和图片评论
  commentPublic.value.fullScreenClick();
};

// 打开图片预览
import { ImagePreview, Toast } from "vant";
import { onMounted } from "vue";
const openInagePreview = (url) => {
  // console.log('打开图片预览')
  ImagePreview([url]);
};
// 给v-html渲染的img标签添加点击事件
const openEditorImg = (e) => {
  // ImagePreview([url]);
  if (e.target.nodeName == "IMG") {
    // console.log('打开图片预览成功')
    ImagePreview([e.target.src]);
  } else {
    if (state.imgCommentFlag) {
      // 如果点击的不是img标签，并且图片输入框显示，就关闭
      state.imgCommentFlag = false;
    }
  }
};
</script>

<style src="../../styles/removeVantcell.css"></style>
<style src="../../styles/editor.css" scoped></style>
<style scoped>
:deep(.van-nav-bar) {
  background: #fff;
}
.nav {
  background-color: #fff;
  margin-bottom: 0;
}
.topicContnet {
  height: 100vh;
  /* padding: 108px 32px; */
  background-color: #fff;
  overflow-x: hidden;
}

/* 活动内容 */
.topicContnet .topicTitle {
  min-height: 500px;
  padding: 30px 32px 34px 32px;
  background-color: #fff;
}
.topicContnet .topicTitle .title {
  font-size: 34px;
  letter-spacing: 0.5px;
  font-weight: bold;
  color: #333;
  line-height: 1.8;
}
.topicTitle h2 {
  font-size: 36px;
  color: #333;
  margin-bottom: 32px;
}
.topicTitle > span {
  font-size: 24px;
  color: #333;
}
.topicTitle .content {
  margin-top: 40px;
}
.topicTitle .content p {
  color: #333;
}

.content .gameInfo_title h4 {
  font-size: 28px;
  color: #333;
  font-weight: 500;
  margin-bottom: 20px;
}
.content .gameInfo_title span {
  font-size: 28px;
  color: #ff6666;
  font-weight: 500;
}
.gameInfo .gameDetail {
  margin: 32px 0;
  width: 686px;
  height: 208px;
  background-color: #f7f8fa;
  padding: 24px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.gameDetail > div {
  display: flex;
  align-items: center;
}
.gameInfo .gameDetail img {
  width: 160px;
  height: 160px;
  border-radius: 20px;
  margin-right: 20px;
  margin-top: 0;
}
.gameInfo .gameDetail > img {
  width: 36px;
  height: 36px;
}
.gameDetail .gameInfo h3 {
  font-size: 32px;
  color: #333;
  font-weight: 500;
  margin-bottom: 28px;
}
.gameDetail .gameInfo p {
  font-size: 24px;
  color: #999999;
}
.beforeTopic {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 40px;
}
.beforeTopic .beforeLeft {
  font-size: 24px;
  color: #999999;
}
.beforeTopic .beforeRight {
  font-size: 24px;
  color: #12cec7;
  font-weight: 500;
  display: flex;
  align-items: center;
}
.beforeTopic .beforeRight img {
  width: 32px;
  height: 32px;
  margin-left: 8px;
}
.empty {
  width: 100%;
  height: 16px;
  background-color: #f0f0f0;
}
/* 评论回复 */
.topicComment {
  padding: 40px 32px 0;
  padding-bottom: 200px;
  background-color: #fff;
}
.topicComment .commentTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.topicComment .commentTitle h3 {
  font-size: 32px;
  color: #333;
  font-weight: 500;
  display: flex;
  align-items: center;
}
.topicComment .commentTitle h3 span {
  font-size: 20px;
  color: #999999;
  margin-left: 8px;
}
.topicComment .commentTitle .sortClass {
  width: 124px;
  height: 40px;
  border-radius: 198px;
  font-size: 20px;
  background-color: #f1f1f1;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.sortClass span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  padding: 0 2px;
  color: #999;
}
.topicComment .commentTitle .sortClass .sortActive {
  width: 60px;
  height: 36px;
  border-radius: 198px;
  background-color: #fff;
}
.commentIndex {
  font-size: 24px;
}
/* 我的回复 */
.myReview {
  position: fixed;
  /* bottom: 50px; */
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  z-index: 9999;
}

.content /deep/ img {
  max-width: 100%;
  margin-top: 32px;
  border-radius: 16px;
}
</style>
<style>
.van-image-preview__swipe {
  background: rgb(0, 0, 0);
  z-index: 999999;
}
.van-popup {
  z-index: 9999 !important;
}
</style>
